import { render } from "./CurrencyEdit.vue?vue&type=template&id=50979e8b"
import script from "./CurrencyEdit.vue?vue&type=script&lang=js"
export * from "./CurrencyEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__